module.exports = __webpack_public_path__ + "img/mkf_qrcode.ca6e2a6b.png";